import styled from 'styled-components';

import { Colors, Fonts } from 'styles/constants';

export const Tooltip = styled.div`
  position: fixed;
  z-index: 9999;
  max-width: 320px;
  padding: 8px 12px;
  border-radius: 6px;
  background: ${Colors.Gray70};
  box-shadow: 0 4px 12px rgba(46, 46, 54, 0.24);
  pointer-events: none;
`;

export const Title = styled.span`
  display: block;
  color: ${Colors.White};
  font-family: ${Fonts.GilroySemiBold};
  font-size: 12px;
`;

export const Description = styled.span`
  display: block;
  margin-top: 4px;
  color: ${Colors.Gray10};
  font-family: ${Fonts.GilroyRegular};
  font-size: 12px;
`;
